// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3VvhW","resendInfoText":"OnGoingPaymentBox_resendInfoText__2O-7p"};